.label {
  position: relative;
  display: flex;
  gap: 20px;
  align-items: center;
  cursor: pointer;
}

.checkboxContainer {
  position: absolute;
  left: -40px;
}

.checkbox {
  position: relative;
  width: 24px;
  height: 24px;
  appearance: none;
  cursor: pointer;
  border: 1px solid #000;
  border-radius: 4px;
  transition: 0.2s;

  /* check icon */
  &::after {
    position: absolute;
    top: 2px;
    left: 2px;
    display: none;
    width: 19px;
    height: 16px;
    content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBzdHJva2U9IiNmZmYiIHN0cm9rZS1taXRlcmxpbWl0PSIyIiBzdHJva2Utd2lkdGg9IjIiIGQ9Im0yLjM1MiA4LjIzNiA1IDUgOS0xMSIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0uMTExIDBoMTl2MTZoLTE5eiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==');
  }

  &:checked {
    background-color: #000;

    &::after {
      display: block;
    }
  }

  &:disabled {
    border-color: rgb(0 0 0 / 30%);

    &:checked {
      background-color: rgb(0 0 0 / 30%);
      border-color: transparent;
    }
  }
}
